import countryListJs from 'country-list-js';

export type Province = { name: string; short?: string; alias?: string[] | null };
export type CountryDetails = {
  name: string;
  continent: string;
  region: string;
  capital: string;
  currency: { code: string; symbol: string; decimal: string };
  dialing_code: string;
  code: { iso2: string; iso3: string };
  provinces: Province[] | undefined;
};

export const usStates = countryListJs.findByIso2('US').provinces as Province[];
export const countries = countryListJs.ls('name') as string[];
export const countriesWithIso2Codes: Array<{ label: string; value: string }> = countryListJs
  .names()
  .map((name: string) => {
    const country = countryListJs.findByName(name);
    if (!country || !country.code?.iso2) {
      return null;
    }

    return {
      label: name,
      value: country.code.iso2,
    };
  })
  .filter((item: { label: string; value: string } | null): item is { label: string; value: string } => item !== null)
  .sort((a, b) => a.label.localeCompare(b.label));

export function getProvincesByCountry(country: string | undefined) {
  const countryDetails: CountryDetails | undefined = countryListJs.findByName(country);

  return (countryDetails?.provinces ?? []).map(province => {
    const regexAtleastOneEnglishLetter = /^(?=[^A-Za-z]*[A-Za-z])[ -~]*$/;
    const label = regexAtleastOneEnglishLetter.test(province.name)
      ? province.name
      : (province.alias?.[0] ?? province.name);

    const value = province.short ?? province.name;

    return { label, value };
  });
}

export function getCountryByCode(code: string): CountryDetails | CountryDetails[] | undefined {
  return countryListJs.findByIso2(code) || countryListJs.findByIso3(code);
}

export function normalizeCountry(country: string): string | undefined {
  const countryList = countries.map(c => ({ label: c, value: c }));
  const matchingCountry = countryList.find(c => c.value.toLowerCase() === country.toLowerCase());
  return matchingCountry?.value;
}

export function normalizeState(country: string, stateValue: string): string {
  if (!stateValue) {
    return stateValue;
  }

  const statesList = getProvincesByCountry(country);

  if (!statesList.length) {
    return stateValue;
  }

  const stateLowerCase = stateValue.toLowerCase();

  const match = statesList.find(
    s => s.value.toLowerCase() === stateLowerCase || s.label.toLowerCase() === stateLowerCase,
  );

  return match?.value || stateValue;
}

